import React, { useEffect, useState } from "react";
import "../Css/About.css";

import mainImg from "../assets/about.jpg";
import smallImg from "../assets/abouta.jpg";
import Home from "./Home"
const About = () => {
  const [years, setYears] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = 8;
    const duration = 1200;
    const stepTime = Math.floor(duration / end);

    const counter = setInterval(() => {
      start += 1;
      setYears(start);
      if (start === end) clearInterval(counter);
    }, stepTime);

    return () => clearInterval(counter);
  }, []);

  return (
    <>
      {/* ================= ABOUT SECTION ================= */}
     <section className="about-intro">
             <div className="about-intro-container">
     
               {/* LEFT IMAGE BLOCK */}
               <div className="about-images">
                 <div className="experience-badge">
                   <h2>8+</h2>
                   <p>Years</p>
                 </div>
     
                 <img
                   src={mainImg}
                   alt="SVK Maid Service"
                   className="main-img"
                 />
     
                 <div className="circle-img">
                   <img src={smallImg} alt="Professional Maid" />
                 </div>
               </div>
     
               {/* RIGHT CONTENT */}
               <div className="about-text">
                 <span className="section-tag">ABOUT US</span>
     
                 <h2>About Us – SVK Maid Service</h2>
     
                 <p>
                   SVK Maid Service is a premier provider of professional maid services.
                   We connect households with skilled, verified and trustworthy domestic
                   help to make everyday life easier and stress-free.
                 </p>
     
                 <ul className="about-points">
                   <li>Experienced Babysitters & Nannies</li>
                   <li>Same-Day or Express Service</li>
                   <li>Satisfaction Guaranteed</li>
                   <li>Pet Care & Daily Assistance</li>
                   <li>Reliable & Verified Staff</li>
                   <li>Full-Time / Part-Time Maids</li>
                 </ul>
     
{/* <Link to="/about-us"> */}
  <button className="about-btn">
    <a href="/about-us">MORE ABOUT US</a>
  </button>
{/* </Link> */}

               </div>
     
             </div>
           </section>



<Home />
      {/* ================= INFO CARDS SECTION ================= */}
      {/* ================= INFO CARDS SECTION ================= */}
<section className="info-cards">
  <div className="info-wrapper">

    {/* PHONE */}
    <div className="info-card">
      <div className="info-icon">☎</div>

      <div className="info-content">
        <h4>Call Us for Service</h4>

        <a
          href="tel:+919152151180"
          className="info-link"
        >
          +91 9152151180
        </a>

        <span>
          Speak with our team for reliable maid services.
        </span>
      </div>
    </div>

    {/* EMAIL */}
    <div className="info-card">
      <div className="info-icon">✉</div>

      <div className="info-content">
        <h4>Email Us for Service</h4>

        <a
          href="mailto:info@svkmaidservice.com"
          className="info-link"
        >
          info@svkmaidservice.com
        </a>

        <span>
          Send us your requirements for quick assistance.
        </span>
      </div>
    </div>

    {/* ADDRESS */}
    <div className="info-card">
      <div className="info-icon">⌖</div>

      <div className="info-content">
        <h4>Visit Our Office</h4>

        <a
          href="https://maps.app.goo.gl/yEW8FqFS8JXqw27Y6"
          target="_blank"
          rel="noopener noreferrer"
          className="info-link address-link"
        >
          Shreepal Complex, 115, Mahatma Gandhi Rd,
          near Sagar Plaza, Kapol Wadi, Ghatkopar West,
          Ghatkopar East, Mumbai, Maharashtra 400086
        </a>

        <span>
          Click to view our location on Google Maps.
        </span>
      </div>
    </div>

  </div>
</section>
    </>
  );
};

export default About;
